module.exports = __webpack_public_path__ + "img/Manage-Pre.c278c46b.jpg";